import { render, staticRenderFns } from "./MultipleUploads.vue?vue&type=template&id=2f8868a6&scoped=true&"
import script from "./MultipleUploads.vue?vue&type=script&lang=js&"
export * from "./MultipleUploads.vue?vue&type=script&lang=js&"
import style0 from "./MultipleUploads.vue?vue&type=style&index=0&id=2f8868a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8868a6",
  null
  
)

export default component.exports